import { axios } from '@Api/axiosClient';

const baseUrl: string = 'api/InviteRedirect';

export interface InviteRedirectCheckResult {
    shouldRedirect: boolean;
    redirectUrl?: string;
}

export const checkInviteRedirectApi = async (
    inviteCode: string,
    requestType: string,
): Promise<InviteRedirectCheckResult | undefined> => {
    try {
        const response = await axios.get<InviteRedirectCheckResult>(
            `${baseUrl}/Check`,
            { params: { inviteCode, requestType } },
        );
        return response.data;
    } catch {
        return undefined;
    }
};
